export const regionState = {
    errorCode : 0,
    statusCode : 0,
    regionList : [],
    message : '',
    UpdatedList : []
}